import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const companyApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "companyApi",
  tagTypes: [],
  endpoints: (builder) => ({
    getKnowledgeBase: builder.query<any, void>({
      query: () => "/knowledge-base",
    }),

    getCompany: builder.query<any, void>({
      query: () => "/company",
    }),

    getCompanyLogo: builder.query<any, void>({
      query: (image) => `/company/logo/${image}`,
    }),

    updateCompany: builder.mutation<any, any>({
      query: (payload) => ({
        url: "/company/update",
        method: "POST",
        body: payload,
      }),
    }),
    updateCompanyLogo: builder.mutation<any, any>({
      query: (payload) => ({
        url: "/company/logo/save",
        method: "POST",
        body: payload,
      }),
    }),
    help: builder.mutation<API.Response.HelpResponse, API.Payload.HelpPayload>({
      query: (payload) => ({
        url: "/help",
        method: "POST",
        body: payload,
      }),
    }),
  }),
})

export const {
  useGetCompanyQuery,
  useGetKnowledgeBaseQuery,
  useUpdateCompanyLogoMutation,
  useUpdateCompanyMutation,
  useGetCompanyLogoQuery,
  useHelpMutation,
} = companyApi
